import linq from 'linq'

export default class ValidationErrorService {
    constructor(e) {
        this.response = e.response
        this.errors = this.response.data.errors
    }

    toString(h) {
        const e = linq
            .from(this.errors)
            .selectMany((x) => linq.from(x.value).flatten())
            .select((x) => h('li', {}, [x]))
            .toArray()

        return h('ul', { class: ['m-0'] }, e)
    }

    firstError() {
        const e = linq
            .from(this.errors)
            .selectMany((x) => linq.from(x.value).flatten())
            .toArray()

        if (e.length) {
            console.log(e[0])
            return e[0]
        }
        return ''
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/ValidationErrorService.js